<template>
  <b-modal ref="searchResultsModal" size="xl" centered class="searchResultsModal" id="searchResultsModal" hide-header hide-footer>
    <template v-if="selectedMessageId">
      <div class="row">
        <div class="col-sm-12">
          <b-btn @click="clearMessageId">Back To Results</b-btn>
          <router-link :to="{name: 'Message', params: { id: selectedMessageId} }" tag="b-btn"><span @click="closeModal">Open Conversation</span></router-link>
          <hr/>
        </div>
      </div>
      <Message :id=selectedMessageId :lightMode="true"/>
    </template>
    <table v-if="!selectedMessageId" class="inbox-table" id="">
      <thead id="tbl-head">
        <tr>
          <th class="customer-column">
            <a href="#">Customer</a>
          </th>
          <th class="conversation-column">
            <a href="#">Conversation</a>
          </th>
          <th class="reply-column">
          </th>
          <th class="ticket-id-column">
            <a href="#">Ticket ID</a>
          </th>
          <th class="time-column">
            <a href="#">Last Updated</a>
          </th>
        </tr>
      </thead>
      <tbody id="tbl-body">
        <tr v-for="message in messages" :key="message.id" :class="message.status === 'active' ? 'active' : 'pending'">
          <td class="customer-column">
            <span @click="setMessageId(message.id)">
              <template v-if="message.customer">
                <span v-if="message.customer.name">{{message.customer.name}}</span>
                <span v-else-if="message.customer.email">{{message.customer.email}}</span>
              </template>
              <template v-else>
                {{message.from}}
              </template>
            </span>
          </td>
          <td class="conversation-column">
            <span @click="setMessageId(message.id)">
              <span class="conversation-title">{{message.subject}}</span>
              <p v-if="message.message_threads.length > 0" class="preview">{{message.message_threads[0].body_text}}</p>
              <p v-else class="preview">{{message.content}}</p>
            </span>
          </td>
          <td class="reply-column">
            <span @click="setMessageId(message.id)">
              <b-badge class="tag reply-tag">{{message.message_threads.length}}</b-badge>
            </span>
          </td>
          <td class="ticket-id-column">
            <a href="#" v-if="message.ticket_id">{{message.ticket_id}}</a>
            <a href="#" v-else>Pending</a>
          </td>
          <td class="time-column">
            {{prettyDate(message.created_at)}}
          </td>
        </tr>
      </tbody>
    </table>

  </b-modal>
</template>

<script>
import Message from './Message'
import { helpersMixins } from '@/mixins/helpersMixins'
export default {
  name: 'SearchResultsModal',
  mixins: [helpersMixins],
  components: {
    Message
  },
  data () {
    return {
      messages: [],
      selectedMessageId: null
    }
  },
  methods: {
    clearMessageId () {
      this.selectedMessageId = null
    },
    setMessageId (id) {
      this.selectedMessageId = id
    },
    getMessages (tag) {
      var vm = this
      this.$http
        .get('/tagged_with', {params: {tag: tag}})
        .then(function (response) {
          vm.messages = response.data
          vm.showModal()
        })
        .catch(e => {
        })
    },
    showModal () {
      this.selectedMessageId = null
      this.$refs.searchResultsModal.show()
    },
    closeModal () {
      this.selectedMessageId = null
      this.$refs.searchResultsModal.hide()
    }
  },
  mounted () {
    this.$root.$on('tagSearchInitiated', (tag) => {
      this.getMessages(tag)
    })
  }
}
</script>
<style scoped>
.inbox-table {
  width: 100%;
  table-layout: fixed;
}
.inbox-table thead th {
  font-weight: 200;
  text-align: left;
  border-bottom: 1px solid #d6dde3;
}
.inbox-table th a {
  color: #93a1af;
}
.inbox-table td a {
  color: #4f5d6b;
}
.inbox-table tr.pending td a {
  color: #4f5d6b;
}
.inbox-table tr.active td a {
  font-weight: bold;
  color: #000;
}
.inbox-table tr.selected td {
  background: #fffcf1;
}
.inbox-table .preview {
  color: #93a1af;
  font-weight: 400;
}
.conversation-column a:hover {
  text-decoration: none;
}
.conversation-column a .conversation-title:hover {
  text-decoration: underline;
}
td.conversation-column p, td.conversation-column span {
  line-height: 1.5em;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.inbox-table {
  font-size: .8rem;
}
.inbox-table .conversation-column {
  width: 50% !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  padding-right: 20px;
}
.inbox-table td {
  text-align: left;
  border-bottom: 1px solid #d6dde3;
  padding: 5px 10px 5px 0;
}
.inbox-table .check-column {
  padding: 5px;
}
.inbox-table .customer-column {
  width: 15%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.inbox-table .time-column {
  width: 13%;
}
.inbox-table .ticket-id-column {
  width: 10%;
}
.inbox-table .mailbox-column {
  width: 5%;
}
.inbox-table .user-column {
  width: 5%;
}
.reply-tag {
  background: #e2e2e2;
  border: 1px solid #cad0d6;
  color: #909ba5;
}
.topic-tag {
  padding: 0 5px;
}
.totals-row {
  float: left;
  color: #7a8da0;
}
.total-conversation, .total-active, .range1, .range2 {
  font-weight: bold;
  color: #676d7a;
}
.viewing-text {
  visibility: visible;
}
.pagination-row {
  float: right;
}
span.oi {
  color:#7a8da0;
}
.all-previous, .previous {
  visibility: visible;
}
.all-next, .next {
  visibility: visible;
}
.user-avatar {
  border-radius: 50%;
  height: 30px;
  width: 30px;
}
.icon-missing {
  color: #57B2CD;
  font-size: 30px;
}
.actions-wrapper {
  display: inline-block;
  background: #FFFFFF;
  height: 55px;
  padding: 0;
  border-radius: 5px;
  position: fixed;
  margin-left: -10%;
  border: 1px solid #DBDBDB;
  box-shadow: 0 10px 200px 10px rgba(0,0,0,.4);
}
.nav-closed .actions-wrapper {
  transition: transform .3s ease-in-out, margin .3s ease-in-out;
}
.nav-open .actions-wrapper {
  transition: transform .3s ease-in-out, margin .3s ease-in-out;
}
ul.inbox-actions {
  list-style: none;
  margin: 0;
  height: 54px;
  position: relative;
  margin: 0px;
  display: flex;
  justify-content: center;
  padding: 7px 5px;
  width: 100%;
}
.closed-tab > .nav-link {
  color: #6C757D;
}
.closed-tab > .nav-link.active {
  color: #FFF;
  background-color: #6C757D;
}
</style>

<style>
.inbox-actions > .actions-menu-wrapper > .actions > li > a > span {
  color: #9A9A9A;
}
.inbox-actions > .actions-menu-wrapper > .message-bar.actions > li > .btn-group.b-dropdown.dropdown > button > a > span {
  color: #9A9A9A;
}
.loading {
  height: 100vh;
  padding: 5vw;
  text-align: center;
  font-size: calc(~"15px + 1.5vw");
  background-color: #fff;
}
.fade-transition {
  transition: opacity 8000ms ease;
}
.fade-transition.loading {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 15px;
  right: 15px;
}
.fade-enter,
.fade-leave {
  opacity: 0;
}
div.modal .modal-dialog.modal-xl {
  width: 900px;
  min-width: 900px;
  max-height: 900px;
}
@media (min-width: 767px) {
  .modal-content {
    max-width: 900px;
    min-width: 900px;
    max-height: 900px;
    overflow: auto!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchResultsModal.vue